import {
  Dialog,
  DialogContent,
  Grid,
  Paper,
  Typography,
  Box,
  IconButton,
  Divider,
  Chip,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import AssessmentIcon from "@mui/icons-material/Assessment";

import AnalysisResult from "./AnalysisResult";
import FilePreview from "./FilePreview";

function DocumentViewerModal({
  open,
  onClose,
  report,
}) {
  if (!report) return null;

  const analysis = {
    relevance: {
      score: Number(report.relevance_score),
    },

    quality: {
      score: Number(report.quality_score),
    },

    duplicate: {
      duplicate: Boolean(report.is_duplicate),
    },

    aiDecision: {
      decision: report.decision,
      reasoning: report.reasoning,
    },
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: "hidden",
        },
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          bgcolor: "#0F172A",
          color: "#fff",
          px: 3,
          py: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          gap={1}
        >
          <AssessmentIcon />

          <Typography
            variant="h6"
            fontWeight={700}
          >
            Evidence Analysis Report
          </Typography>
        </Box>

        <IconButton
          onClick={onClose}
          sx={{
            color: "#fff",
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent
        sx={{
          p: 3,
          bgcolor: "#F8FAFC",
        }}
      >
        <Grid
          
          spacing={3}
        >
          {/* LEFT SIDE */}
          <Grid item xs={12} md={7}>
            <Paper
              elevation={0}
              sx={{
                p: 2,
                height: 800,
                overflow: "hidden",
                border: "1px solid #E5E7EB",
              }}
            >
              <Typography
                variant="h5"
                fontWeight={600}
                gutterBottom
              >
                Document Preview
              </Typography>

              <Divider sx={{ mb: 2 }} />

              <Box
                sx={{
                  height: 760,
                  overflow: "hidden",
                  bgcolor: "#fff",
                }}
              >
                <FilePreview report={report} />
              </Box>
            </Paper>
          </Grid>

          {/* RIGHT SIDE */}
          <Grid item xs={12} md={5}>
            <AnalysisResult analysis={analysis} />
          </Grid>

          {/* EXTRACTED TEXT */}
          <Grid item xs={12}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                border: "1px solid #E5E7EB",
                mt: 3,
              }}
            >
              <Typography
                variant="h5"
                fontWeight={600}
                gutterBottom
              >
                Extracted OCR Text
              </Typography>

              <Chip
                size="small"
                label={`${report.extracted_text?.length || 0} characters`}
                sx={{ mb: 2 }}
              />

              <Box
                sx={{
                  bgcolor: "#F9FAFB",
                  borderRadius: 2,
                  p: 2,
                  maxHeight: 250,
                  overflow: "auto",
                  fontFamily: "monospace",
                  fontSize: 13,
                  whiteSpace: "pre-wrap",
                  border: "1px solid #E5E7EB",
                }}
              >
                {report.extracted_text ||
                  "No text extracted"}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default DocumentViewerModal;